import { create } from 'zustand';

import type { EffectKey, PresetName } from './presets.js';
import { applyPreset, type Settings } from './schema.js';
import { browserStorage, loadSettings, saveSettings } from './storage.js';

/** Overlay state for graphics settings. Persists to localStorage; Phase 5 adds the API sync. */
export interface SettingsState {
  settings: Settings;
  setPreset: (name: PresetName) => void;
  update: (partial: Partial<Settings>) => void;
  setEffect: (key: EffectKey, enabled: boolean) => void;
  replace: (settings: Settings) => void;
}

const storage = browserStorage();

export const useSettingsStore = create<SettingsState>((set) => ({
  settings: loadSettings(storage),
  setPreset: (name) => set((s) => ({ settings: applyPreset(s.settings, name) })),
  update: (partial) => set((s) => ({ settings: { ...s.settings, ...partial } })),
  setEffect: (key, enabled) =>
    set((s) => ({
      settings: { ...s.settings, effects: { ...s.settings.effects, [key]: enabled } },
    })),
  replace: (settings) => set({ settings }),
}));

useSettingsStore.subscribe((state) => saveSettings(storage, state.settings));
